import React, { Component } from 'react';
import { Route } from 'react-router';
import { Landing } from './components/Landing/Landing';
import { BrowserRouter } from 'react-router-dom';

import { LanRecogerEnvio } from './actions/Landing/LanRecogerEnvio';
import { MensajeFinal } from './components/Flujo/MensajeFinal';
import { PdfViewer } from './actions/PdfViewer';
import { EliminaSuscripcion } from './components/ListaNegra/EliminaSuscripcion';


export default class App extends Component {
  displayName = App.name

  render() {
    return (
        <BrowserRouter>
            <div>
                <Route path='/' exact={true} component={Landing} />
                <Route path='/RecogerEnvio' component={LanRecogerEnvio} />
                <Route path='/MensajeFinal' component={MensajeFinal} />
                <Route path='/PdfViewer' component={PdfViewer} />
                <Route path='/EliminaSuscripcion' component={EliminaSuscripcion} />
            </div>
        </BrowserRouter>
    );
  }
}
